/*
 * Downpay in the sticky add-to-cart bar.
 * Downpay renders its purchase options once (#downpay-block, placed via its app embed) and
 * adds/removes `selling_plan` on every add-to-cart form, sticky one included.
 * This element shows a compact copy of those options in the sticky bar and keeps both in sync:
 * choosing here clicks the matching Downpay radio, choosing in Downpay updates this copy.
 */
if (!customElements.get('downpay-sticky-options')) {
  customElements.define(
    'downpay-sticky-options',
    class DownpayStickyOptions extends HTMLElement {
      connectedCallback() {
        this.uid = `DownpaySticky-${Math.random().toString(36).slice(2, 8)}`;
        this.onSourceChange = () => this.syncFromSource();
        this.observer = new MutationObserver(() => this.attach());
        this.observer.observe(document.body, { childList: true, subtree: true });
        this.attach();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.block?.removeEventListener('change', this.onSourceChange);
      }

      sourceInputs() {
        return Array.from(document.querySelectorAll('#downpay-block input[name="purchase_option"]'));
      }

      // (Re)build when Downpay renders or re-renders its options (e.g. on variant change).
      attach() {
        const inputs = this.sourceInputs();
        const signature = inputs.map((input) => `${input.value}|${this.labelFor(input)}`).join('||');
        if (signature === this.signature) return;
        this.signature = signature;

        const block = document.getElementById('downpay-block');
        if (this.block !== block) {
          this.block?.removeEventListener('change', this.onSourceChange);
          this.block = block;
          this.block?.addEventListener('change', this.onSourceChange);
        }

        this.render(inputs);
      }

      labelFor(input) {
        const label = input.id ? document.querySelector(`label[for="${input.id}"]`) : null;
        return (label ? label.textContent : input.value).trim();
      }

      render(inputs) {
        this.innerHTML = '';
        if (inputs.length < 2) {
          this.hidden = true;
          return;
        }

        const fieldset = document.createElement('fieldset');
        fieldset.className = 'downpay-sticky__options';
        inputs.forEach((source, index) => {
          const id = `${this.uid}-${index}`;
          const wrapper = document.createElement('div');
          wrapper.className = 'downpay-sticky__option';

          const radio = document.createElement('input');
          radio.type = 'radio';
          radio.name = this.uid;
          radio.id = id;
          radio.value = source.value;
          radio.checked = source.checked;
          radio.addEventListener('change', () => {
            if (radio.checked && !source.checked) source.click();
          });

          const label = document.createElement('label');
          label.htmlFor = id;
          label.className = 'text-small uppercase';
          label.textContent = this.labelFor(source);

          wrapper.append(radio, label);
          fieldset.append(wrapper);
        });

        this.append(fieldset);
        this.hidden = false;
      }

      syncFromSource() {
        const checked = this.sourceInputs().find((input) => input.checked);
        if (!checked) return;
        this.querySelectorAll('input[type="radio"]').forEach((radio) => {
          radio.checked = radio.value === checked.value;
        });
      }
    }
  );
}
